import { render, staticRenderFns } from "./collective-settings.vue?vue&type=template&id=4bafeca6&"
import script from "./collective-settings.vue?vue&type=script&lang=js&"
export * from "./collective-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports